const QuidSourceQualityType = Object.freeze({
  TOP_TIER: 'TOP_TIER',
  MID_TIER: 'MID_TIER',
  OTHER_QUALITY: 'OTHER_QUALITY'
})
export default QuidSourceQualityType
// RESERVE BELOW
